<template>
  <div
    class="social-sharing"
    :class="isStickyState ? 'sticky top-24' : 'flex items-center'"
  >
    <div class="flex flex-col">
      <h3 class="mb-[20px] text-[20px] font-medium leading-[24px]">Соцсети</h3>
      <div
        class="flex"
        :class="
          isStickyState ? 'max-h-145 flex-col items-end' : 'justify-between'
        "
      >
        <a
          v-for="social in socials"
          :key="`social-sharing-item-${social.id}`"
          :href="social.share"
          target="_blank"
          class="text-smaller-caps flex items-center justify-between font-bold"
          :class="
            isStickyState
              ? 'mb-8 last:mb-0 hover:text-safrone-100'
              : 'mr-[16px] last:mr-0'
          "
        >
          <template v-if="isTextState">
            {{ isMobile ? social.mobileTitle : social.title }}
          </template>
          <SvgIcon
            v-if="!isTextState"
            :name="social.icon"
            class="size-5 text-new-test-black"
          ></SvgIcon>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  state: {
    type: String,
    default: 'sticky',
    validate: (value) => ['sticky', 'text', 'horizontal'].includes(value),
  },
});

const { isMobile } = useBreakpoint();
const route = useRoute();

const socials = [
  {
    id: 0,
    title: 'ВКонтакте',
    mobileTitle: 'ВК',
    share: `//vk.com/share.php?url=https://histrf.ru${route.fullPath}`,
    icon: 'socials/vk',
  },
  {
    id: 3,
    title: 'Одноклассники',
    mobileTitle: 'ОК',
    share: `https://connect.ok.ru/offer?url=https://histrf.ru${route.fullPath}`,
    icon: 'socials/ok',
  },
  {
    id: 4,
    title: 'Telegram',
    mobileTitle: 'TG',
    share: `https://t.me/share/url?url=https://histrf.ru${route.fullPath}`,
    icon: 'socials/telegram',
  },

  // {
  //   id: 1,
  //   title: 'Facebook',
  //   mobileTitle: 'FB',
  //   share: `//www.facebook.com/sharer.php?s=100&p[url]=https://histrf.ru${
  //     this.url || this.$route.fullPath
  //   }`,
  //   icon: 'socials/facebook-bordered',
  // },
  //        {
  //          id: 2,
  //          title: 'Twitter',
  //          mobileTitle: 'TW',
  //          share: `//twitter.com/share?text=${this.title}&url=https://histrf.ru${
  //            this.url || this.$route.fullPath
  //          }`,
  //          icon: 'socials/twitter',
  //        },
];

const isStickyState = computed(() => {
  return props.state === 'sticky';
});

const isTextState = computed(() => {
  return props.state === 'text';
});
</script>

<style lang="scss"></style>
